<template>
  <div>
    <v-autocomplete
      v-model="selected"
      :items="get_data.customers"
      :label="lang.customers.title_s"
      :filter="filter"
      :no-data-text="lang.customers.datatable.no_results"
      prepend-inner-icon="mdi-account"
      item-text="name"
      item-value="id"
      filled
      chips
      :clearable="clearable"
      clear-icon="mdi-broom"
      autocomplete="off"
      hide-details
      class="customers-autocomplete"
    >
      <template v-slot:selection="data">
        <v-chip
          :input-value="data.selected"
          class="chip--select-multi"
        >
          {{ `#${data.item.id} ${data.item.name}` }}
        </v-chip>
      </template>
      <template v-slot:item="data">
        <v-list-item-content>
          <v-list-item-title>
            <v-row class="px-0 mx-0">
              <v-col cols="12" class="pa-0 px-1">{{ `#${data.item.id}  ${data.item.name}` }}</v-col>
            </v-row>
          </v-list-item-title>
          <v-list-item-subtitle>
            <v-row class="px-0 mx-0">
              <v-col cols="6" class="pa-0 px-1">
                <v-icon
                  small
                  color="blue"
                >
                  mdi-phone
                </v-icon>
                {{ data.item.phone | phoneMask }}
              </v-col>
              <v-col cols="6" class="pa-0 px-1">
                <v-icon
                  small
                  color="green"
                >
                  mdi-card-bulleted
                </v-icon>
                {{ data.item.identity | cpfMask }}
              </v-col>
            </v-row>
          </v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  mixins: [ appdata, utils ],
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      selected: (this.value ? this.value : 0)
    }
  },
  watch: {
    selected: {
      deep: true,
      handler (newVal) {
        if (JSON.stringify(this.value) !== JSON.stringify(newVal)) this.$emit('input', this.selected)
      }
    },
    value: {
      deep: true,
      handler (newVal) {
        if (JSON.stringify(this.selected) !== JSON.stringify(newVal)) this.selected = this.value
      }
    }
  },
  methods: {
    filter (item, queryText) {
      if (item && queryText) {
        let data = JSON.stringify(item)
        // return Object.values(item).some((val) => val.includes(queryText))
        return (data.toLowerCase().trim().search(queryText.toLowerCase()) > -1)
      }
      return false
    }
  }
}
</script>

<style lang="scss">
#app .customers-autocomplete {
  border-radius: 0px !important;
  margin-top: -2px;
  .v-label--active {
    top: 13px !important;
  }
  .v-select__selections {
    margin-top: 0px !important;
    padding-top: 17px !important;
    min-height: 58px !important;
    .v-chip {
      margin-bottom: 0px !important;
      background: #1976d2 !important;
      color: #fff !important;
      .v-chip__content {
        line-height: 15px !important;
        .v-chip__close {
          margin-top: -1px;
          color: #fff !important;
        }
      }
    }
  }
}
</style>
